import http from "./http"

let prefix = "/api";
// let prefix = "/cardpay/api";

const API = {
    checkoutSubmit: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/submit", method: "post", data: obj}),
    checkoutPayResult: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/pay-result", method: "get", params: obj}),
    checkoutPaymentAccount: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/payment-account", method: "put", data: obj}),
    checkoutReverseMatch: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/reverse-match", method: "post", data: obj}),

    checkoutTxIdMatch: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/txId-match", method: "post", data: obj}),
    checkoutSubmitTxId: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/submit-txId", method: "post", data: obj}),
    checkoutInfo: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/info", method: "get", params: obj}),
    checkoutParseTxId: obj => http({url: prefix + "/v1/sdk/card-pay/checkout/parse-txId", method: "post", data: obj}),

    checkoutTransactions: param => http({url: prefix + "/checkout/transactions/" + param, method: "get"}),
    checkoutTransactionsInitialize: obj => http({
        url: prefix + "/checkout/transactions/initialize",
        method: "post",
        data: obj
    }),

    appCheckout: param => http({url: prefix + "/app/checkout/" + param, method: "get", hideLoading: true}),
    channelDisplay: param => http({url: prefix + "/app/checkout/channel-display/" + param, method: "get", hideLoading: true}),
    transactionsQuery: obj => http({url: prefix + "/v1/sdk/transactions/query/" + obj.apiKey, method: "get", params: {platformReference:obj.platformReference}, hideLoading: true}),
    phonePaymentTransactionStatus: param => http({url: prefix + "/v1/sdk/phone-payment/transaction-status/" + param, method: "get"}),//todo暂未使用
    phonePaymentInitialize: obj => http({
        url: prefix + "/v1/sdk/phone-payment/initialize",
        method: "post",
        data: obj
    }),

    ussdInitialize: obj => http({
        url: prefix + "/v1/sdk/ussd/initialize",
        method: "post",
        data: obj
    }),


    v1SdkMnoInitialize: obj => http({url: prefix + "/v1/sdk/mno/initialize", method: "post", data: obj}),
    v1SdkDirectInitialize: obj => http({url: prefix + "/v1/sdk/direct/initialize", method: "post", data: obj}),

    v1SdkSysInitialize: obj => http({url: prefix + "/v1/sdk/sys/initialize", method: "post", data: obj, hideLoading: true}),

    confirmPayment: obj => http({url: prefix + "/v1/sdk/confirm-payment", method: "post", data: obj, hideLoading: true}),

    v1Banks: obj => http({url: prefix + "/v1/banks", method: "get", params: obj}),

}

export default API
